/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable sort-vars */
/* eslint-disable sort-keys */
/* eslint-disable max-lines-per-function */
/* eslint-disable max-lines */
import "./error.scss";
import "../../assets/scss/main.scss";
import React from "react";
import { Box, Button, Card, ThemeProvider, Typography } from "@mui/material";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import RefreshIcon from "@mui/icons-material/Refresh";
import theme from "../../assets/theme/theme";
import { GLOBALSETTINGS } from "../../data/constants";

export default function PageNotFound() {
  return (
    <ThemeProvider theme={theme}>
      <>
        <div className="error-page p-4">
          <div className="text-center mb-4">
            <img
              src="/logo-transparent.svg"
              alt="logo"
              className="signin-logo"
            />
          </div>
          <Card variant="outlined" className="card p-4 text-center">
            <Typography variant="h2" color="error" className="error-title">
              404
            </Typography>
            <Typography variant="h5" className="error-sub-title">
              OOPS! NOTHING WAS FOUND
            </Typography>

            <Typography variant="body1" className="page-error-text">
              The page you are looking for might have been removed or is
              temporarily unavailable.
            </Typography>
            <div className="text-center">
              <Box sx={{}} className="action-container">
                <Button onClick={() => window.location.reload()} variant="contained" startIcon={<RefreshIcon />}>
                  Try again
                </Button>

                <Button  onClick={() => window.location.href = GLOBALSETTINGS.DEFAULT_PAGE}  variant="contained" startIcon={<HomeRoundedIcon />}>
                  Back to Dashboard
                </Button>
              </Box>
            </div>
          </Card>
        </div>
      </>
    </ThemeProvider>
  );
}
